import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private requestCount = 0;
  private readonly loaderSubject = new BehaviorSubject<boolean>(false);
  public readonly isLoading$ = this.loaderSubject.asObservable();

  isLoading(): Observable<boolean> {
    return this.isLoading$;
  }

  show(): void {
    this.requestCount++;
    if (this.requestCount === 1) {
      this.loaderSubject.next(true);
    }
  }

  hide(): void {
    if (this.requestCount > 0) {
      this.requestCount--;
      if (this.requestCount === 0) {
        this.loaderSubject.next(false);
      }
    }
  }

  reset(): void {
    this.requestCount = 0;
    this.loaderSubject.next(false);
  }
}
